import { mergeProps } from "react-aria";
import {
  TextField as AriaTextField,
  TextFieldProps,
} from "react-aria-components";

import { sharedStyles } from "../../styles";
import { LabelAlign } from "../../../types";

interface Props extends TextFieldProps {
  labelAlign?: LabelAlign;
}

export function _TextField(props: Props) {
  const { labelAlign = "vertical" } = props;
  const className = sharedStyles.field;

  return (
    <AriaTextField
      {...mergeProps(props, { className })}
      data-label-orientation={labelAlign}
    />
  );
}
